module.exports = __webpack_public_path__ + "static/img/happy1.1164562b.png";